import * as dashboard from './dashboard'
import * as admin from './admin'
import * as bootstrapSlider from './bootstrap-slider'
import * as pathUtils from './pathUtils'
import * as mask from './jquery.mask'
import * as scripts from './scripts'
import * as fourth from './fourth'
import * as forms from './forms'
import * as browsercheck from './browserCheck'
import * as menuMobile from './menu-mobile'
import * as popUp from './popUp'
//import * as Sentry from "@sentry/browser";
//import { BrowserTracing } from "@sentry/tracing";



// WEBPACK FOOTER //
// ./assets/js/main.js